export const miniMenu = () => {
	const menu =
		document.querySelector('.construction-waste .menu') || document.querySelector('.industrial-waste .menu') || document.querySelector('.rec-and-up .menu') || document.querySelector('.bdo .menu') || document.querySelector('.destruction .menu') || document.querySelector('.resources .menu');

	if (!menu) {
		return;
	}

	const menuSwiper = menu.querySelector('.menu__swiper')?.swiper;
	const menuList = menu.querySelector('.menu__list');
	const menuLinks = Array.from(menu.querySelectorAll('.menu__list-link'));
	const sections = menuLinks
		.map((link) => {
			const sectionId = link.getAttribute('href')?.slice(1);
			const item = link.closest('.menu__list-item');
			const section = sectionId ? document.getElementById(sectionId) : null;

			return section && item ? { item, link, section } : null;
		})
		.filter(Boolean);

	if (!sections.length) {
		return;
	}

	let activeLink = null;

	const setActiveItem = (nextActiveLink) => {
		const didChange = activeLink !== nextActiveLink;
		activeLink = nextActiveLink;
		menu.classList.toggle('menu--active', Boolean(nextActiveLink));
		menuList?.classList.toggle('menu__list--active', Boolean(nextActiveLink));

		menuLinks.forEach((link) => {
			const isActive = link === nextActiveLink;
			link.classList.toggle('menu__list-link--active', isActive);
			link.closest('.menu__list-item')?.classList.toggle('menu__list-item--active', isActive);
		});

		if (!didChange || !menuSwiper || !nextActiveLink) {
			return;
		}

		const activeIndex = menuLinks.indexOf(nextActiveLink);
		const activeItem = nextActiveLink.closest('.menu__list-item');
		const swiperRect = menuSwiper.el.getBoundingClientRect();
		const itemRect = activeItem?.getBoundingClientRect();
		const isItemVisible = Boolean(
			itemRect && itemRect.left >= swiperRect.left && itemRect.right <= swiperRect.right
		);
		const isItemTooFarLeft = Boolean(itemRect && itemRect.left <= swiperRect.left + 24);

		if (activeIndex >= 0 && (!isItemVisible || isItemTooFarLeft)) {
			const slidesToCenter = Math.max(Math.floor(menuSwiper.slidesPerViewDynamic() / 2), 1);
			const targetIndex = Math.max(activeIndex - slidesToCenter, 0);

			menuSwiper.slideTo(targetIndex, 300);
		}
	};

	const updateActiveSection = () => {
		const offset = menu.offsetHeight + 166;
		let currentLink = null;

		sections.forEach(({ link, section }) => {
			const sectionTop = section.getBoundingClientRect().top;

			if (sectionTop - offset <= 0) {
				currentLink = link;
			}
		});

		setActiveItem(currentLink);
	};

	const updateState = () => {
		updateActiveSection();
	};

	menuLinks.forEach((link) => {
		link.addEventListener('click', (event) => {
			event.preventDefault();

			const sectionId = link.getAttribute('href')?.slice(1);
			const section = sectionId ? document.getElementById(sectionId) : null;

			if (!section) {
				return;
			}

			const topOffset = menu.offsetHeight + 100;
			const targetPosition = section.getBoundingClientRect().top + window.scrollY - topOffset;

			window.scrollTo({
				top: targetPosition,
				behavior: 'smooth',
			});
		});
	});

	let ticking = false;

	const onScroll = () => {
		if (ticking) {
			return;
		}

		ticking = true;

		window.requestAnimationFrame(() => {
			updateState();
			ticking = false;
		});
	};

	updateState();
	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', updateState);
} 